import { isDateInPast } from "@/helpers/date";

const getDefaultState = () => ({
  plans: [],
});

export default {
  namespaced: true,
  state: () => getDefaultState(),
  actions: {
    plans({ commit }, payload) {
      commit("plans", payload);
    },
    resetState({ commit }) {
      commit("resetState");
    },
  },
  mutations: {
    plans(state, payload) {
      state.plans = payload;
    },
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
  },
  getters: {
    plans: state => state.plans,
    planId: (state, getters, rootState) => rootState?.currentPlanDetails?.siteDetails?.planId,
    currentProductDetails: (state, getters, rootState) =>
      rootState?.currentPlanDetails?.siteDetails,
    currentPlanType: (state, getters) => getters.currentProductDetails?.planDetails?.type,
    isPaidPlan: (state, getters) => getters.currentProductDetails?.planDetails?.isPaid,
    isTrialPlan: (state, getters) => getters.currentProductDetails?.planDetails?.isTrial,
    isFreePlan: (state, getters) => !getters.isPaidPlan && !getters.isTrialPlan,
    isExpired: (state, getters) =>
      getters.currentProductDetails?.expiry
        ? isDateInPast(getters.currentProductDetails.expiry)
        : false,
    orderId: (state, getters, rootState) => rootState?.currentPlanDetails?.siteDetails?.orderId,
  },
};
